import { Reducer } from "@ctra/utils";

import { cleanup } from "../../utils/reducer";
import types from "./types";
import { SavedCharts } from "./typings";

export const initialState: SavedCharts = {};

/**
 * Reducer of list of saved charts
 * @param state
 * @param action
 * @category Reducer
 */
export const savedChartsReducer: Reducer<SavedCharts> = (state, action) => {
  const { type, payload } = action;

  switch (type) {
    case types.FETCH_SAVED_CHARTS.fulfilled: {
      return payload as SavedCharts;
    }
    case types.UPDATE_TABS.fulfilled:
    case types.UPDATE_CHARTS.fulfilled: {
      const { pageKey, savedCharts } = payload;
      return {
        ...state,
        [pageKey]: savedCharts
      };
    }
  }

  return state;
};

export default cleanup<SavedCharts>(initialState)(savedChartsReducer);
